<template>
    <div class="main_center" style="margin: 0px 0px; padding-top: 8px;">
        <PmSearch ref="searchRef"
                  :form.sync="form"
                  :options.sync="searchConfigs"
                  label-width="72px"
                  @reset="resetSearch"
                  @search="seachBtn">
            <template v-slot:purchaseItemSlot="purchaseItemSlot">
                <div class="multiple-item-wrap">
                    <el-select v-model="form.purchaseItemId" filterable :filter-method="filterOption" placeholder="请选择" style="width: 100%">
                        <el-option-group
                                style="width: 100%"
                                v-for="group in purchaseCatalogList"
                                :key="group.label"
                                :label="group.label">
                            <el-option
                                    v-for="item in group.options"
                                    style="width: 100%"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.id">
                                <span style="float: right">{{ item.name }}</span>
                                <span style="float: left; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                            </el-option>
                        </el-option-group>
                    </el-select>
                </div>
            </template>
            <template v-slot:afterSearchComSlot>
                <el-col  :span="18" style="padding-bottom: 16px">
                    <el-button size="small"  icon="el-icon-plus" type="primary"
                               @click="routerAdd('')">新增</el-button>
                    <el-button size="small" type="danger" plain icon="el-icon-delete"
                               @click="deleteSelectItem()">删除
                    </el-button>
                </el-col>
            </template>
        </PmSearch>
        <div class="content">
            <el-table
                :data="tableData"
                v-loading="dataListLoading"
                ref="multipleTable"
                :height="tableMaxHeight"
                :key="randomKey"
                stripe
                border
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    fixed
                    label="序号"
                    type="index"
                    :index="indexMethod"
                    width="50"
                    align="center"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column fixed type="selection" align="center"
                                 :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="操作" align="left" width="180" fixed="right">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            title="编辑"
                            @click="routerAdd(scope.row)">编辑</el-button>
                        <el-button
                                type="text"
                                size="small"
                                title="删除" @click="deleteById(scope.row)">删除</el-button>
                        <el-button
                                type="text"
                                size="small"
                                :title="scope.row.isShow?'隐藏':'显示'"
                                @click.stop="changeIsShow(scope.row)">{{scope.row.isShow?'隐藏':'显示'}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                        label="采购需求标准"
                        prop="demandStandardName"
                        align="left"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    label="所属品目"
                    prop="purchaseItemName"
                    header-align="left"
                    align="left"
                    min-width="150"
                    :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{scope.row.purchaseItem && scope.row.purchaseItem.purchaseItemName}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="品目编号"
                        prop="purchaseItemCode"
                        header-align="left"
                        align="left"
                        min-width="120"
                        :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{scope.row.purchaseItem && scope.row.purchaseItem.purchaseItemCode}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="发布部门"
                    prop="releaseDeptName"
                    header-align="left"
                    align="left"
                    min-width="120"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        label="修改人"
                        prop="updateUser"
                        header-align="left"
                        align="left"
                        width="180"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="修改时间"
                    prop="updateTime"
                    header-align="left"
                    align="left"
                    width="180"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        label="创建人"
                        prop="createUser"
                        header-align="left"
                        align="left"
                        width="180"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="创建时间"
                    prop="createTime"
                    header-align="left"
                    align="left"
                    width="180"
                    :show-overflow-tooltip="true"
                ></el-table-column>
            </el-table>
            <pagination
                class="limit"
                :page-sizes="[10, 20, 50, 100]"
                :total="total"
                :page.sync="pageIndex"
                :limit.sync="pageSize"
                @pagination="paginationChange"
            ></pagination>
        </div>
        <el-dialog
                :title="diaTitle"
                width="600px"
                :visible.sync="visible">
            <el-form :model="dataForm"  :rules="dataRule" ref="dataForm"
                     label-width="150px">
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="所属品目：" prop="purchaseItemId">
                            <el-select filterable clearabled v-model="dataForm.purchaseItemId" :filter-method="filterOption" placeholder="请选择" style="width: 100%">
                                <el-option-group
                                        style="width: 100%"
                                        v-for="group in purchaseCatalogList"
                                        :key="group.label"
                                        :label="group.label">
                                    <el-option
                                            v-for="item in group.options"
                                            style="width: 100%"
                                            :key="item.value"
                                            :label="item.name"
                                            :value="item.id">
                                        <span style="float: right">{{ item.name }}</span>
                                        <span style="float: left; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                                    </el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="22">
                        <el-form-item label="发布部门：" prop="releaseDeptName">
                            <el-input v-model="dataForm.releaseDeptName" placeholder="请填写" class="limit-word-input" maxlength="100" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="22">
                        <el-form-item label="采购需求标准：" prop="demandStandardName">
                            <el-button @click="uploadFile">{{dataForm.demandStandardName?'重新上传':'上传'}}</el-button>
                            <p style="cursor: pointer" @click="downloadFileByUrl(dataForm.demandStandardName,dataForm.demandStandardPath)">{{dataForm.demandStandardName}}</p>
                        </el-form-item>
                    </el-col>
                    <el-col :span="22">
                        <el-form-item label="是否展示：" prop="isShow">
                            <el-radio-group v-model="dataForm.isShow">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="0">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>

                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="visible = false">取消</el-button>
              <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
            </span>
        </el-dialog>
        <upload ref="uploadComRef" accept-file-type=".pdf,.docx,.doc,.rar,.wps,.ofd" @uploadSuccess="uploadSuccess"></upload>
    </div>
</template>
<script>
import Pagination from "@/components/Pagination.vue";
import {httpMixinsList,httpSysPurcatalogList,httpMixinsCommonPost} from "@/server/purchase";
import PmSearch from "@/components/PmSearch/index.vue";
import upload from "@/components/affixMsg/upload";
export default {
    name: "busWitnessTable",
    components: {
        Pagination,
        PmSearch,
        upload
    },
    data() {
        return {
            tableMaxHeight: document.documentElement.clientHeight - 275,
            dataListLoading: false,
            form: {
                demandStandardName:"",
                releaseDeptName:''
            },
            searchConfigs: [
                {
                    type:'input',
                    key:'demandStandardName',
                    label:'模板名称',
                    isShow:true
                },
                {
                    type:'input',
                    key:'releaseDeptName',
                    label:'发布部门',
                    isShow:true
                },
                {
                    type:'select',
                    key:'purchaseItemId',
                    label:'采购品目',
                    slot:'purchaseItemSlot',
                },
            ],
            diaTitle:'编辑采购需求标准',
            visible:false,
            dataForm:{
                purchaseItemId:'',
                releaseDeptName:'',
                demandStandardName:'',
                isShow:1,
            },
            purchaseCatalogList:[],
            purchaseCatalogListCopy:[],
            dataRule:{
                purchaseItemId:[
                    {required: true, message: '请选择所属品目', trigger: 'change'}
                ],
                releaseDeptName:[
                    {required: true, message: '请填写发布部门', trigger: 'blur'}
                ],
                demandStandardName:[
                    {required: true, message: '请上传采购需求标准', trigger: 'blur'}
                ],
            },
            businessType: "GC",
            checkList1: "",
            pageSize: 10, //每页条数
            pageIndex: 1, //当前页
            total: 0, //总条数
            tableData: [],
            randomKey:Math.random(),
            multipleSelection: [],
            user: "", //角色类型
            formData: {},
            transactionCenterList: [],
        };
    },
    props: {
        busWitnessTableType: {
            type: String,
            default: ""
        }
    },
    filters: {
        ellipsis(text, num) {
            if (text.length > num) {
                return text.substring(0, num) + "...";
            } else {
                return text;
            }
        }
    },
    watch:{

    },
    activated() {
        this.getDataList();
        this.requestSysPurcatalogItemData();
    },
    created() {

    },
    mounted() {
        const that = this;
        let resizeTag = true;
        window.onresize = () => {
            if (resizeTag) {
                //防抖动
                that.ifmove();
                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                }, 1000);
            }
        };
        that.ifmove();
    },
    computed: {},

    methods: {
        downloadFileByUrl(fileName, fileContent) {
            let element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(fileContent));
            element.setAttribute('download', fileName);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        },
        uploadSuccess(res){
            this.dataForm.demandStandardName = res.fileName;
            this.dataForm.demandStandardPath = res.filepath;
        },
        uploadFile(){
            this.$refs.uploadComRef.selectFileClick();
        },
        filterOption(query) {
            this.purchaseCatalogList = JSON.parse(JSON.stringify(this.purchaseCatalogListCopy));
            this.purchaseCatalogList.forEach(group => {
                group.options = group.options.filter(option =>
                    option.name.toLowerCase().includes(query.toLowerCase()) || option.value.toLowerCase().includes(query.toLowerCase())
                );
            });
        },
        requestSysPurcatalogItemData(){
            httpSysPurcatalogList({}).then((res) => {
                this.purchaseCatalogList = res.data;
                this.purchaseCatalogListCopy = JSON.parse(JSON.stringify(res.data));
            })
        },
        dataFormSubmit(){
            this.$refs.dataForm.validate((valid) => {
                if (valid) {
                    this.formLoading = true;
                    httpMixinsCommonPost("/purchase/demandStandard/saveOrUpdate", this.dataForm)
                        .then(res => {
                            this.formLoading = false;
                            if (res.data.code == "1") {
                               this.visible = false;
                               this.getDataList();
                                this.$message({
                                    type: "success",
                                    message: res.data.msg
                                });
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.data.msg
                                });
                            }
                        });
                }
            });
        },

        ifmove() {
            let tableMaxHeight = document.documentElement.clientHeight - 328;
            this.pageSize = parseInt(tableMaxHeight / 50) || 1;
            this.$nextTick(() => {
                this.tableMaxHeight = tableMaxHeight;
            });
            // this.getDataList()
        },
        getDataList() {
            // 获取列表数据
            this.dataListLoading = true;
            httpMixinsList("/purchase/demandStandard/pagedList", {
                page: this.pageIndex,
                rows: this.pageSize,
                filter: {
                    purchaser:false,
                    ...this.form
                }
            })
            .then((data) => {
                this.dataListLoading = false;
                if (data) {
                    this.tableData = data.data.rows || [];
                    this.total = data.data.total || 0;
                    this.$refs.multipleTable.doLayout();
                }
            });

        },

        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        paginationChange(obj) {
            this.pageIndex = obj.page || 1;
            this.pageSize = obj.limit || 5;
            this.getDataList();
        },


        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        resetSearch(){
            this.form.purchaseItemId = '';
        },
        //搜索按钮
        seachBtn() {
            this.pageIndex = 1;
            this.getDataList();
        },
        reflash() {
            //刷新按钮
            this.pageIndex = 1;
            this.form = {}
            this.getDataList();
        },
        routerAdd(row){ //新增
          this.visible = true;
          if(row){
              this.dataForm = {...row};
          }else{
              this.dataForm = {
                  purchaseItemId:'',
                  releaseDeptName:'',
                  demandStandardName:'',
                  isShow:1,
              }
              this.$refs.dataForm.resetFields()
          }
            this.purchaseCatalogList = JSON.parse(JSON.stringify(this.purchaseCatalogListCopy))
        },

        changeIsShow(row){
            httpMixinsCommonPost('/purchase/demandStandard/updateShow', {
                id: row.id,
                isShow:row.isShow?0:1
            }).then(res => {
                if (res.data.code == '1') {
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    })
                    this.getDataList();
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            })
        },
        deleteById(item) {
            this.$confirm(`确定要删除该数据?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                httpMixinsCommonPost('/purchase/demandStandard/delete', {
                    id: item.id
                }).then(res => {
                    if (res.data.code == '1') {
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        })
                        this.getDataList();
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                })
            })
        },
        deleteSelectItem() {
            let ids = new Array();
            this.multipleSelection.forEach(key => {
                ids.push(key.id)
            })

            if (ids != "" || ids.length > 0) {


                this.$confirm(`确定要删除所选数据?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    httpMixinsCommonPost('/purchase/demandStandard/delete', {
                        idList: ids
                    }).then(res => {
                        if (res.data.code == '1') {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            })
                            this.getDataList();
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                    })
                })


            } else {
                this.$message({
                    type: 'error',
                    message: "未选择删除项。"
                })
            }

        },

    },

    destroyed() {
        window.onresize = null;
    }
};
</script>
<style lang="less" scoped>
//列表页面



</style>
